





































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Label from '@/components/common/elements/Label.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import DialogMasterSelectTable from '@/components/common/modules/DialogMasterSelectTable.vue';

@Component({
  components: { Label, Dialog, DialogMasterSelectTable }
})
export default class MasterSelectButton extends Vue {
  /** 項目ラベルname要素 */
  @Prop({ default: '' })
  private name?: string;
  /** 項目ラベル表示テキスト */
  @Prop({ default: '' })
  private labelText?: string;

  /** マスタ選択ダイアログのタイトル */
  @Prop({ default: '' })
  private dialogTitle?: string;
  /** マスタ選択ダイアログのテーブルに表示するカラムの配列 */
  @Prop({ default: () => [] })
  private columns!: Array<any>;
  /** マスタ選択ダイアログのテーブルに表示するデータの配列 */
  @Prop({ default: () => [] })
  private body!: Array<any>;
  /** 取得ボタンの表示・非表示 */
  @Prop({ default: true })
  private isBtnVisible?: boolean;
  /** 編集モード判定制御値 */
  @Prop({ default: true })
  private isEditMode?: boolean;

  /** マスタ選択ダイアログの表示制御値 */
  private dialogStatus = false;

  /**
   * 値が変更されたときの処理
   */
  @Emit('inputOperation')
  public inputOperation(data: any) {
    return data;
  }

  /**
   * マスタ選択ダイアログで値が選択されたときの処理
   */
  catchTableDataRelay(data: any) {
    this.dialogStatus = false;
    this.inputOperation({ name: this.name, value: data.selectData });
  }

  changeDialogStatus(_: any) {
    this.dialogStatus = false;
  }
}
